Object.defineProperty(exports, "__esModule", { value: true });
exports.isRootFieldOnNonRootBase = exports.enhanceType = exports.validateResolvedType = exports.resolveRegisteredOrInferredType = void 0;
const graphql_1 = require("graphql");
const Field_1 = require("../Field");
const fieldType_1 = require("./fieldType");
const SchemaRoot_1 = require("../../schema/SchemaRoot");
function resolveRegisteredOrInferredType(target, fieldName, explicitType) {
    if (explicitType) {
        return fieldType_1.resolveTypeOrThrow(explicitType, target, fieldName);
    }
    return fieldType_1.inferTypeOrThrow(target, fieldName);
}
exports.resolveRegisteredOrInferredType = resolveRegisteredOrInferredType;
function validateResolvedType(target, fieldName, type) {
    if (!graphql_1.isOutputType(type)) {
        throw new Field_1.FieldError(target, fieldName, `Validation of type failed. Resolved type must be a GraphQLOutputType.`);
    }
    return true;
}
exports.validateResolvedType = validateResolvedType;
function enhanceType(originalType, isNullable) {
    let finalType = originalType;
    if (!isNullable) {
        finalType = new graphql_1.GraphQLNonNull(finalType);
    }
    return finalType;
}
exports.enhanceType = enhanceType;
function isRootFieldOnNonRootBase(base, fieldName) {
    const isRoot = SchemaRoot_1.isSchemaRoot(base);
    if (isRoot) {
        return false;
    }
    if (SchemaRoot_1.mutationFieldsRegistry.has(base, fieldName)) {
        return true;
    }
    if (SchemaRoot_1.queryFieldsRegistry.has(base, fieldName)) {
        return true;
    }
    return false;
}
exports.isRootFieldOnNonRootBase = isRootFieldOnNonRootBase;
//# sourceMappingURL=services.js.map